import { cn } from '@/app/utils'

import { CloseButton } from './CloseButton'
import styles from './progressbar.module.css'

type Props = {
  activeIndex: number
  slidesLength: number
  onSlideClick: (index: number) => void
  onClose: () => void
}

export const ProgressBar = ({
  activeIndex,
  slidesLength,
  onSlideClick,
  onClose
}: Props) => (
  <div className="absolute top-12 z-10 flex w-full items-center gap-12 px-24 pt-8 xxs:flex-col xxs:px-16">
    <div className="flex w-full items-center gap-4">
      {Array.from({ length: slidesLength }).map((_, index) => (
        <button
          key={index}
          aria-label={`Шаг сторис №${index}`}
          className={cn(
            'h-4 w-full rounded-16',
            index < activeIndex ? 'bg-bronze-40' : 'bg-grey-40',
            index === activeIndex ? styles.fillingAnimation : ''
          )}
          onClick={() => onSlideClick(index)}
        />
      ))}
    </div>

    <CloseButton onClick={onClose} />
  </div>
)
